import * as BaseComponents from './01.base'
import * as AccountComponents from './02.account'
import * as ProfileComponents from './03.profile'
import * as BookingComponents from './04.booking'
import * as SecurityComponents from './05.security'
import * as ModifyReservationComponents from './06.modify-reservation'
import * as SpaSoftComponents from './07.spa-soft'

export const {
  Carousel,
  AccordionDark,
  ShareIcons,
  Tabs,
  ToggleDetails,
  LoadingDots,
  Overlay,
  Slider,
  VideoPlayer,
  // Forms
  SitecoreForm,
  FilteringForm,
  // Lists
  SimpleList,
  LoadMorePagination,
  // Sidebar
  SidebarLinks
} = BaseComponents

export const {
  LoginForm,
  RegistrationForm,
  ResetForm,
  MyStays,
  PreArrivalFrom,
  FanRegistrationForm,
  FanOneTimeCodeForm
} = AccountComponents

export const {
  ProfileForm,
} = ProfileComponents

export const {
  RoomStayCard,
  CheckoutForm,
  UpcomingStay,
} = BookingComponents

export const {
  VgsForm,
} = SecurityComponents

export const {
  ModifyReservationMain
} = ModifyReservationComponents

export default {
  ...BaseComponents,
  ...AccountComponents,
  ...ProfileComponents,
  ...BookingComponents,
  ...SecurityComponents,
  ...ModifyReservationComponents,
  ...SpaSoftComponents
}
